import { useState, useEffect } from 'react';
import { useLimitedActivityStoreAuto } from './useLimitedActivityStoreAuto';

export const useProgressCalculation = (step: number) => {
  const [progress, setProgress] = useState<number>(0);
  const useLimitedActivityStore = useLimitedActivityStoreAuto();
  const durationInMonths = useLimitedActivityStore((state) => state.durationInMonths);

  useEffect(() => {
    setProgress(Math.min(durationInMonths, step));
  }, [durationInMonths, step]);

  return progress;
};
